/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DashboardListEntryCategory = {
    Referrals: 'Referrals',
    Census: 'Census',
    WorkflowEfficiency: 'Workflow efficiency',
    ExaCareAiFeatures: 'ExaCare AI features',
    DeepDives: 'Deep dives',
} as const;
export type DashboardListEntryCategory = typeof DashboardListEntryCategory[keyof typeof DashboardListEntryCategory];


export function instanceOfDashboardListEntryCategory(value: any): boolean {
    for (const key in DashboardListEntryCategory) {
        if (Object.prototype.hasOwnProperty.call(DashboardListEntryCategory, key)) {
            if (DashboardListEntryCategory[key as keyof typeof DashboardListEntryCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DashboardListEntryCategoryFromJSON(json: any): DashboardListEntryCategory {
    return DashboardListEntryCategoryFromJSONTyped(json, false);
}

export function DashboardListEntryCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardListEntryCategory {
    return json as DashboardListEntryCategory;
}

export function DashboardListEntryCategoryToJSON(value?: DashboardListEntryCategory | null): any {
    return value as any;
}

export function DashboardListEntryCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): DashboardListEntryCategory {
    return value as DashboardListEntryCategory;
}

